import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Switch,
  FormControlLabel,
} from "@mui/material";
import CustomTypography from "../../globalStyles/fonts";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import { forecastParameterService } from "../../utils/services/forecast-parameter.service";

const InitialData = {
  name: "",
  key: "",
};

const ForecastParameterModal = ({
  open,
  handleClose,
  onAddData,
  selectedParameter,
}) => {
  const [parameter, setParameter] = useState(InitialData);
  const [formErrors, setFormErrors] = useState({});

  const validateForm = () => {
    const errors = {};
    if (!parameter.name) {
      errors.name = "Name is required";
    }
    if (!parameter.key) {
      errors.key = "Key is required";
    } else if (!/^[a-zA-Z]/.test(parameter.key)) {
      errors.key =
        "Key must contain only letters, no spaces, numbers, or special characters";
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  useEffect(() => {
    if (selectedParameter) {
      setParameter(selectedParameter);
    } else {
      resetData();
    }
  }, [selectedParameter]);

  const resetData = () => {
    setParameter(InitialData);
    setFormErrors({});
  };

  const handleEditData = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      await forecastParameterService.edit(selectedParameter._id, {
        name: parameter.name,
        key: parameter.key,
      });
      onAddData && onAddData();
      toast.success("Forecast parameter updated successfully!");
      resetData();
      handleClose();
    } catch (error) {
      toast.error("Failed to update forecast parameter.");
      console.error(error);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    try {
      await forecastParameterService.create({
        name: parameter.name,
        key: parameter.key,
      });
      onAddData && onAddData();
      toast.success("Forecast parameter created successfully!");
      resetData();
      handleClose();
    } catch (error) {
      toast.error("Failed to create forecast parameter.");
      console.error(error);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        handleClose();
        resetData();
      }}
      maxWidth="md"
      aria-labelledby="form-dialog-title"
      fullWidth
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <DialogTitle id="form-dialog-title" style={{ fontSize: 24 }}>
          {selectedParameter ? "Update" : "Create"} Forecast Parameter
        </DialogTitle>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <Divider style={{ marginBottom: 10 }} />
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <CustomTypography>
              Name <span style={{ color: "red" }}>*</span>
            </CustomTypography>
            <TextField
              size="small"
              name="name"
              value={parameter.name}
              onChange={(e) =>
                setParameter({ ...parameter, name: e.target.value })
              }
              fullWidth
              placeholder="Enter parameter name"
              margin="dense"
              error={!!formErrors.name}
              helperText={formErrors.name}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTypography>
              Key <span style={{ color: "red" }}>*</span>
            </CustomTypography>
            <TextField
              size="small"
              name="key"
              value={parameter.key}
              onChange={(e) =>
                setParameter({ ...parameter, key: e.target.value })
              }
              fullWidth
              placeholder="Enter parameter key (letters only)"
              margin="dense"
              error={!!formErrors.key}
              helperText={formErrors.key}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions style={{ paddingBottom: 15, paddingRight: 15 }}>
        <Button
          onClick={() => {
            handleClose();
            resetData();
          }}
          color="primary"
          variant="outlined"
          style={{
            fontFamily: "Poppins",
            fontSize: 14,
            fontWeight: 600,
            textTransform: "none",
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={(e) =>
            selectedParameter ? handleEditData(e) : handleSave(e)
          }
          color="primary"
          variant="contained"
          style={{ textTransform: "none" }}
        >
          {selectedParameter ? "Update" : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ForecastParameterModal;
